export default __webpack_public_path__ + "static/media/ispo-img@2x.25e7ce45.webp";